import { useMemo } from 'react'
import { checkModuleAccess } from '@/modules'
import { useSelector } from 'react-redux'

/**
 * Check if tenants subscription includes the given module
 * @param {*} subscriptionModule the module to check
 * @param {*} dependencies dependencies to trigger the check
 * @returns boolean
 */
const useCheckModuleAccess = (subscriptionModule, dependencies = []) => {
  const { moduleAccess } = useSelector(state => state.permission)
  const loading = useSelector(state => state.subscription.details.loading)

  return useMemo(
    () => checkModuleAccess(subscriptionModule),
    [...dependencies, moduleAccess, loading],
  )
}

export default useCheckModuleAccess
